/**
 * Created by fers on 26.08.16.
 */

let allLocalesToSwitch = {
    'en': 'English',
    'cs': "Česky",
};

export const internationalLangCodes = {
	'en': 'en-US',
	'cs': 'cs-CZ',
    'sk': 'sk-SK',
    'hu': 'hu-HU',
};

let localesMyAppSupports = Object.keys(internationalLangCodes);

export const DEFAULT_LOCALE = 'cs';
export const DEFAULT_CURRENCY = 'CZK';
export const DEFAULT_COUNTRY = 'CZ';
export const DEFAULT_TIMEZONE = "Europe/Prague";

export function getPriceInCurrency(price : number, currency : string) {
    if (currency === DEFAULT_CURRENCY) {
        return price;
    } else if (currency === 'EUR') {
        let pr = price / 24.5;
        if (pr < 0.5) {
            return Math.round(pr * 100) / 100;
        } else if (pr < 0.9) {
            return Math.round(pr * 10) / 10;
        } else if (pr < 8) {
            return Math.round(pr * 50) / 50 - 0.05;
        } else if (pr < 40) {
            return Math.round(pr) - 0.05;
        } else {
            return Math.round(pr);
        }
    } else {
        return -1;
    }
}

/**
 * Returns languages that user can switch to
 * 
 * @returns locales
 */
export function getLocalesMyAppSupports() : Array<string> {
    return localesMyAppSupports;
}

/**
 * 
 * @returns 
 */
export function getSupportedLocales() {
    return allLocalesToSwitch;
}

export function translateObjectMap(textObject) {
	let translateObject = {};

	textObject.forEach(text => {
		translateObject[text.locale] = text.content;
	});

	return translateObject;
}

export function translateMapToObject(translateObject) {
	let textObject = [];

	Object.keys(translateObject).forEach(locale => {
		textObject.push({
			content: translateObject[locale],
			locale: locale
		});
	});

	return textObject;
}
